import script from "./CoinsStore.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoinsStore.vue?vue&type=script&lang=ts&setup=true"

import "./CoinsStore.vue?vue&type=style&index=0&id=67ced620&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67ced620"]])

export default __exports__